import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

export function useSpotlight() {
  const { hasRequiredProduct } = useUserProducts();
  const hasSpotlight = hasRequiredProduct(PRODUCT.SPOTLIGHT);

  return { hasSpotlight };
}
